import type { CalendarEventData } from "~/modules/events/ts/CalendarEventData";

export const useExportEventUrl = (data: CalendarEventData) => {
  return `data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:${data.dates[0]}%0ADTEND:${data.dates[1]}%0ASUMMARY:${data.text}%0ADESCRIPTION:${data.details}%0ALOCATION:${data.location}%0AEND:VEVENT%0AEND:VCALENDAR%0A`;
};
